interface AmplifyAuthConfig {
  region: string;
  userPoolId: string;
  userPoolWebClientId: string;
  mandatorySignIn: boolean;
  authenticationFlowType: "USER_PASSWORD_AUTH" | "USER_SRP_AUTH";
  oauth: object;
}

const amplifyAuthConfig: AmplifyAuthConfig = {
  region: window.appConfig.aws.amplifyRegion,
  userPoolId: window.appConfig.aws.amplifyPoolId,
  userPoolWebClientId: window.appConfig.aws.amplifyPoolWebClientId,
  mandatorySignIn: false,
  authenticationFlowType: "USER_PASSWORD_AUTH",
  oauth: {},
};

export const amplifyConfig = {
  aws_project_region: window.appConfig.aws.amplifyRegion,
  aws_cognito_region: window.appConfig.aws.cognitoRegion,
  aws_user_pools_id: window.appConfig.aws.amplifyPoolId,
  aws_user_pools_web_client_id: window.appConfig.aws.amplifyPoolWebClientId,
  oauth: {},
  Auth: amplifyAuthConfig,
};
